import { ChatMessage } from '../types'

export const INITIAL_MESSAGE: ChatMessage = {
  id: 'init',
  text: 'Welcome to Short Stop Food Mart! Home of the BBQ Train. How can I help you today?',
  sender: 'bot',
  timestamp: new Date(),
  actions: [
    { label: 'View Hours', value: 'hours', type: 'trigger' },
    { label: 'Location', value: 'location', type: 'trigger' },
    { label: 'BBQ Menu', value: 'menu', type: 'link' },
    { label: 'Order Catering', value: 'catering', type: 'link' },
  ],
}

export const getBotResponse = (input: string): ChatMessage => {
  const lowerInput = input.toLowerCase()

  let text =
    "I'm not sure about that. You can call us at 812-334-0266 for more info!"
  let actions = undefined

  if (lowerInput.includes('hour') || lowerInput.includes('open')) {
    text = 'We are open Mon-Sat 6am-10pm, and Sun 7am-9pm. Come visit us!'
  } else if (
    lowerInput.includes('address') ||
    lowerInput.includes('location') ||
    lowerInput.includes('where')
  ) {
    text = 'We are located at the corner of Smith Road & East 10th Street.'
    actions = [{ label: 'Get Directions', value: '/contact', type: 'link' }]
  } else if (
    lowerInput.includes('bbq') ||
    lowerInput.includes('food') ||
    lowerInput.includes('menu')
  ) {
    text =
      'We have the best BBQ in town! Check out our BBQ Thursdays and daily menu.'
    actions = [{ label: 'View Menu', value: '/menu', type: 'link' }]
  } else if (
    lowerInput.includes('catering') ||
    lowerInput.includes('party') ||
    lowerInput.includes('order')
  ) {
    text =
      "Planning an event? We'd love to cater it! You can place an order directly through our website."
    actions = [
      { label: 'Start Catering Order', value: '/catering', type: 'link' },
    ]
  } else if (lowerInput.includes('phone') || lowerInput.includes('call')) {
    text = 'Give us a ring at 812-334-0266.'
  }

  return {
    id: Date.now().toString(),
    text,
    sender: 'bot',
    timestamp: new Date(),
    actions,
  }
}
